var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-table-card",
    { staticClass: "card" },
    [
      _c(
        "md-tabs",
        { staticClass: "md-transparent", attrs: { "md-fixed": "md-fixed" } },
        [
          _c(
            "md-tab",
            { attrs: { id: "tab1", "md-label": "my videos" } },
            [
              _c("associated-dialog", { ref: "playlistsDialog" }),
              _c(
                "form",
                {
                  attrs: { id: "search", novalidate: "novalidate" },
                  on: {
                    submit: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.search.apply(null, arguments)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "filters" },
                    [
                      _c(
                        "md-layout",
                        { staticClass: "search", attrs: { "md-align": "end" } },
                        [
                          _c(
                            "md-layout",
                            {
                              staticClass: "searchContainer",
                              attrs: { "md-flex": "33", "md-align": "end" }
                            },
                            [
                              _c(
                                "md-layout",
                                [
                                  _c(
                                    "md-input-container",
                                    [
                                      _c("label", [_vm._v("Search")]),
                                      _c("md-input", {
                                        on: {
                                          keypress: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.search()
                                          }
                                        },
                                        model: {
                                          value: _vm.searchText,
                                          callback: function($$v) {
                                            _vm.searchText = $$v
                                          },
                                          expression: "searchText"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm.searchText != ""
                                ? _c(
                                    "md-layout",
                                    { attrs: { "md-flex": "15" } },
                                    [
                                      _c(
                                        "md-button",
                                        {
                                          staticClass: "md-icon-button btn",
                                          on: { click: _vm.cleanSearchText }
                                        },
                                        [
                                          _c("md-icon", {
                                            staticClass: "icon",
                                            attrs: {
                                              "md-iconset": "fa fa-trash-alt"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "md-layout",
                                { attrs: { "md-flex": "10" } },
                                [
                                  _c(
                                    "md-button",
                                    {
                                      staticClass: "md-icon-button btn",
                                      attrs: {
                                        type: "submit",
                                        disabled: _vm.loading
                                      }
                                    },
                                    [
                                      _c("md-icon", {
                                        staticClass: "icon",
                                        attrs: { "md-iconset": "fa fa-search" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.loading
                        ? _c("stitch-loader", {
                            attrs: { loading: _vm.loading, size: 45 }
                          })
                        : _c(
                            "div",
                            [
                              _c("div", { staticClass: "titleLine styleRow" }, [
                                _c("p", { staticClass: "rowElements" }, [
                                  _vm._v("Image")
                                ]),
                                _c(
                                  "p",
                                  {
                                    staticClass: "rowElements sortable",
                                    on: {
                                      click: function($event) {
                                        return _vm.onSort("name")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Name " +
                                        _vm._s(
                                          _vm.sort.name === "name"
                                            ? _vm.sort.type === "desc"
                                              ? "↓"
                                              : "↑"
                                            : ""
                                        )
                                    )
                                  ]
                                ),
                                _c("p", { staticClass: "rowElements" }, [
                                  _vm._v("Encoding Status")
                                ]),
                                _c("p", { staticClass: "rowElements" }, [
                                  _vm._v("Publish Status")
                                ]),
                                _c(
                                  "p",
                                  {
                                    staticClass: "rowElements sortable",
                                    on: {
                                      click: function($event) {
                                        return _vm.onSort("lastUpdated")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Updated " +
                                        _vm._s(
                                          _vm.sort.name === "lastUpdated"
                                            ? _vm.sort.type === "desc"
                                              ? "↓"
                                              : "↑"
                                            : ""
                                        )
                                    )
                                  ]
                                ),
                                !_vm.selectedItems.length > 0
                                  ? _c("p", { staticClass: "rowElements" })
                                  : _c(
                                      "button",
                                      {
                                        staticClass: "rowElements btnBulk",
                                        on: { click: _vm.deleteMultipleItems }
                                      },
                                      [_vm._v("Delete selected")]
                                    )
                              ]),
                              _vm._l(_vm.mediaItems, function(mediaItem) {
                                return _c(
                                  "div",
                                  {
                                    key: mediaItem._id,
                                    staticClass: "rowVideos styleRow",
                                    class: {
                                      selected: _vm.selectedItems.includes(
                                        mediaItem._id
                                      )
                                    }
                                  },
                                  [
                                    _c("input", {
                                      staticClass: "checkBox",
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: _vm.selectedItems.includes(
                                          mediaItem._id
                                        )
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.selectMediaItem(
                                            mediaItem._id
                                          )
                                        }
                                      }
                                    }),
                                    mediaItem.encodingStatus === "completed"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "imgContainer media-item-img"
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "media-item-img",
                                              attrs: {
                                                src: _vm.getVideoPoster(
                                                  mediaItem
                                                ),
                                                alt: mediaItem.name,
                                                width: 230,
                                                height: 150
                                              }
                                            })
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "imgContainer media-item-img divText"
                                          },
                                          [
                                            _c("p", { staticClass: "status" }, [
                                              _vm._v(
                                                _vm._s(mediaItem.encodingStatus)
                                              )
                                            ]),
                                            _c(
                                              "sub",
                                              { staticClass: "infoText" },
                                              [
                                                _vm._v(
                                                  "Please refresh to update status"
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                    _c(
                                      "div",
                                      { staticClass: "rowElements itemClick" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "nameText",
                                            attrs: { title: mediaItem.name }
                                          },
                                          [_vm._v(_vm._s(mediaItem.name))]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "rowElements itemClick" },
                                      [_vm._v(_vm._s(mediaItem.encodingStatus))]
                                    ),
                                    mediaItem.status === "public"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "rowElements itemClick"
                                          },
                                          [_vm._v("live")]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rowElements itemClick",
                                            on: {
                                              click: function($event) {
                                                return _vm.selectMediaItem(
                                                  mediaItem._id
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(mediaItem.status))]
                                        ),
                                    _c(
                                      "div",
                                      { staticClass: "rowElements itemClick" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("moment")(
                                              mediaItem.lastUpdated,
                                              "from"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    !_vm.selectedItems.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rowElements iconsContainer"
                                          },
                                          [
                                            _c(
                                              "md-button",
                                              {
                                                staticClass:
                                                  "md-icon-button md-raised btn",
                                                attrs: { id: "info-mediaitem" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.viewAssociatedPlaylists(
                                                      mediaItem._id,
                                                      mediaItem.serie,
                                                      mediaItem.episodeNumber,
                                                      mediaItem.seasonNumber
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("md-icon", {
                                                  staticClass: "icon",
                                                  attrs: {
                                                    "md-iconset": "fa fa-list"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "md-button",
                                              {
                                                staticClass:
                                                  "md-icon-button md-raised btn",
                                                attrs: { id: "edit-mediaitem" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.isEncodingInProgress(
                                                      mediaItem.encodingStatus
                                                    )
                                                      ? _vm.itemNotEditable()
                                                      : _vm.editMediaItem(
                                                          mediaItem._id
                                                        )
                                                  }
                                                }
                                              },
                                              [
                                                _c("md-icon", {
                                                  staticClass: "icon",
                                                  attrs: {
                                                    "md-iconset":
                                                      "fa fa-pencil-alt"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c("copy-video-url-menu", {
                                              attrs: {
                                                "media-item": mediaItem,
                                                "is-loading":
                                                  _vm.loadingDistributionFor[
                                                    mediaItem._id
                                                  ],
                                                distributions:
                                                  _vm.fetchedDistributions[
                                                    mediaItem._id
                                                  ]
                                              },
                                              on: {
                                                fetch: function($event) {
                                                  return _vm.fetchDistributionsFor(
                                                    mediaItem
                                                  )
                                                }
                                              }
                                            }),
                                            _vm.isAdmin() ||
                                            _vm.isAccountAdmin()
                                              ? _c(
                                                  "md-button",
                                                  {
                                                    staticClass:
                                                      "md-icon-button md-raised btn",
                                                    attrs: {
                                                      id: "delete-mediaitem"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deleteMediaItem(
                                                          mediaItem.name,
                                                          mediaItem._id,
                                                          mediaItem.status,
                                                          mediaItem.includeInMarketplace
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("md-icon", {
                                                      staticClass: "icon",
                                                      attrs: {
                                                        "md-iconset":
                                                          "fa fa-trash-alt"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rowElements iconsContainer"
                                          },
                                          [
                                            _c(
                                              "md-button",
                                              {
                                                staticClass:
                                                  "md-icon-button md-raised btn",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.viewAssociatedPlaylists(
                                                      mediaItem._id,
                                                      mediaItem.serie,
                                                      mediaItem.episodeNumber,
                                                      mediaItem.seasonNumber
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("md-icon", {
                                                  staticClass: "icon",
                                                  attrs: {
                                                    "md-iconset": "fa fa-list"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "md-button",
                                              {
                                                staticClass:
                                                  "md-icon-button md-raised btn",
                                                attrs: {
                                                  id: "btnBulkDiv",
                                                  disabled: _vm.selectedItems.includes(
                                                    mediaItem._id
                                                  )
                                                    ? false
                                                    : true
                                                },
                                                on: {
                                                  click: _vm.deleteMultipleItems
                                                }
                                              },
                                              [
                                                _c("md-icon", {
                                                  staticClass: "icon",
                                                  attrs: {
                                                    "md-iconset":
                                                      "fa fa-trash-alt"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                  ]
                                )
                              })
                            ],
                            2
                          ),
                      _c("md-table-pagination", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasMediaItemsToDisplay,
                            expression: "hasMediaItemsToDisplay"
                          }
                        ],
                        staticClass: "md-pagination",
                        attrs: {
                          "md-size": _vm.currentPagination.size,
                          "md-total": _vm.totalMediaItems,
                          "md-page": _vm.currentPagination.page,
                          "md-label": "Videos",
                          "md-separator": "of",
                          "md-page-options": [10, 25, 50, 100]
                        },
                        on: { pagination: _vm.onPageChanged }
                      }),
                      _vm.hasNoResults
                        ? _c(
                            "div",
                            { attrs: { id: "no-results" } },
                            [
                              _c("md-icon", {
                                staticClass: "md-accent",
                                attrs: {
                                  "md-iconset": "fa fa-exclamation-circle"
                                }
                              }),
                              _vm._v("No items to show")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "md-tab",
            { attrs: { id: "tab2", "md-label": "licensed videos" } },
            [
              _c("rental-price-dialog", {
                ref: "rentalPriceDialog",
                attrs: { "playlists-map": _vm.playlistsMap },
                on: { "price-updated": _vm.searchLicenses }
              }),
              _c(
                "form",
                {
                  attrs: { id: "search-licenses", novalidate: "novalidate" },
                  on: {
                    submit: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.searchLicenses.apply(null, arguments)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "filters" },
                    [
                      _c(
                        "md-layout",
                        { staticClass: "search", attrs: { "md-align": "end" } },
                        [
                          _c(
                            "md-layout",
                            {
                              staticClass: "searchContainer",
                              attrs: { "md-flex": "33", "md-align": "end" }
                            },
                            [
                              _c(
                                "md-layout",
                                [
                                  _c(
                                    "md-input-container",
                                    [
                                      _c("label", [_vm._v("Search")]),
                                      _c("md-input", {
                                        on: {
                                          keypress: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.searchLicenses()
                                          }
                                        },
                                        model: {
                                          value: _vm.searchTextLicenses,
                                          callback: function($$v) {
                                            _vm.searchTextLicenses = $$v
                                          },
                                          expression: "searchTextLicenses"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm.searchTextLicenses != ""
                                ? _c(
                                    "md-layout",
                                    { attrs: { "md-flex": "15" } },
                                    [
                                      _c(
                                        "md-button",
                                        {
                                          staticClass: "md-icon-button btn",
                                          on: {
                                            click: _vm.cleanSearchTextLicenses
                                          }
                                        },
                                        [
                                          _c("md-icon", {
                                            staticClass: "icon",
                                            attrs: {
                                              "md-iconset": "fa fa-trash-alt"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "md-layout",
                                { attrs: { "md-flex": "10" } },
                                [
                                  _c(
                                    "md-button",
                                    {
                                      staticClass: "md-icon-button btn",
                                      attrs: {
                                        type: "submit",
                                        disabled: _vm.loading
                                      }
                                    },
                                    [
                                      _c("md-icon", {
                                        staticClass: "icon",
                                        attrs: { "md-iconset": "fa fa-search" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.loading
                        ? _c("stitch-loader", {
                            attrs: { loading: _vm.loading, size: 45 }
                          })
                        : _c(
                            "div",
                            [
                              _c("div", { staticClass: "titleLine styleRow" }, [
                                _c("p", { staticClass: "rowElements" }, [
                                  _vm._v("Image")
                                ]),
                                _c("p", { staticClass: "rowElements" }, [
                                  _vm._v("Name")
                                ]),
                                _c("p", { staticClass: "rowElements" }, [
                                  _vm._v("Price")
                                ]),
                                _c("p", { staticClass: "rowElements" }, [
                                  _vm._v("Tags")
                                ]),
                                _c("p", { staticClass: "rowElements" }, [
                                  _vm._v("Playlists")
                                ]),
                                !_vm.selectedLicensedItems.length ||
                                !(_vm.isAdmin() || _vm.isAccountAdmin())
                                  ? _c("p", { staticClass: "rowElements" })
                                  : _c(
                                      "button",
                                      {
                                        staticClass: "rowElements btnBulk",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            return _vm.deleteLicensedMediaItems()
                                          }
                                        }
                                      },
                                      [_vm._v("Delete selected")]
                                    )
                              ]),
                              _vm._l(_vm.mediaItemsLicenses, function(
                                mediaItem
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: mediaItem._id,
                                    staticClass: "rowVideos styleRow",
                                    class: {
                                      selected: _vm.selectedLicensedItems.includes(
                                        mediaItem._id
                                      )
                                    }
                                  },
                                  [
                                    _c("input", {
                                      staticClass: "checkBox",
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: _vm.selectedLicensedItems.includes(
                                          mediaItem._id
                                        )
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.selectLicensedMediaItem(
                                            mediaItem._id
                                          )
                                        }
                                      }
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "imgContainer media-item-img"
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "media-item-img",
                                          attrs: {
                                            src: _vm.getVideoPoster(mediaItem),
                                            alt: mediaItem.name,
                                            width: 230,
                                            height: 150
                                          }
                                        })
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "rowElements itemClick" },
                                      [_vm._v(_vm._s(mediaItem.name))]
                                    ),
                                    _c("div", { staticClass: "rowElements" }, [
                                      _vm._v(
                                        "$ " +
                                          _vm._s(
                                            _vm.getMediaItemPrice(mediaItem)
                                          )
                                      )
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "rowElements" },
                                      _vm._l(mediaItem.tags, function(tag) {
                                        return _c(
                                          "span",
                                          { staticClass: "tag" },
                                          [_vm._v(_vm._s(tag))]
                                        )
                                      }),
                                      0
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "rowElements itemClick" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getPlaylistNames(mediaItem)
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "rowElements iconsContainer"
                                      },
                                      [
                                        _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "md-icon-button md-raised btn",
                                            on: {
                                              click: function($event) {
                                                return _vm.viewAssociatedPlaylists(
                                                  mediaItem._id,
                                                  mediaItem.serie,
                                                  mediaItem.episodeNumber,
                                                  mediaItem.seasonNumber
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("md-icon", {
                                              staticClass: "icon",
                                              attrs: {
                                                "md-iconset": "fa fa-list"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "md-icon-button md-raised btn",
                                            on: {
                                              click: function($event) {
                                                return _vm.openRentalDialog(
                                                  mediaItem
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("md-icon", {
                                              staticClass: "icon",
                                              attrs: {
                                                "md-iconset": "fa fa-pencil-alt"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c("copy-video-url-menu", {
                                          attrs: {
                                            "media-item": mediaItem,
                                            "is-loading":
                                              _vm.loadingDistributionFor[
                                                mediaItem._id
                                              ],
                                            distributions:
                                              _vm.fetchedDistributions[
                                                mediaItem._id
                                              ]
                                          },
                                          on: {
                                            fetch: function($event) {
                                              return _vm.fetchDistributionsFor(
                                                mediaItem
                                              )
                                            }
                                          }
                                        }),
                                        _vm.isAdmin() || _vm.isAccountAdmin()
                                          ? _c(
                                              "md-button",
                                              {
                                                staticClass:
                                                  "md-icon-button md-raised btn",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteLicensedMediaItem(
                                                      mediaItem.name,
                                                      mediaItem._id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("md-icon", {
                                                  staticClass: "icon",
                                                  attrs: {
                                                    "md-iconset":
                                                      "fa fa-trash-alt"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          ),
                      _c("md-table-pagination", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasMediaItemsLicensesToDisplay,
                            expression: "hasMediaItemsLicensesToDisplay"
                          }
                        ],
                        staticClass: "md-pagination",
                        attrs: {
                          "md-size": _vm.currentPaginationLicenses.size,
                          "md-total": _vm.totalMediaItemsLicenses,
                          "md-page": _vm.currentPaginationLicenses.page,
                          "md-label": "Videos",
                          "md-separator": "of",
                          "md-page-options": [10, 25, 50, 100]
                        },
                        on: { pagination: _vm.onPageChangedLicenses }
                      }),
                      _vm.hasNoResultsLicensed
                        ? _c(
                            "div",
                            { attrs: { id: "no-results-licenses" } },
                            [
                              _c("md-icon", {
                                staticClass: "md-accent",
                                attrs: {
                                  "md-iconset": "fa fa-exclamation-circle"
                                }
                              }),
                              _vm._v("No items to show")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-da2a8dce", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da2a8dce","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/mediaItem/MediaItemTable.vue
// module id = 921
// module chunks = 0